import React, { useEffect } from 'react';
import Footer from '../components/Footer';

const Terms = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <main className="min-h-screen bg-earth-50 dark:bg-earth-900 pt-28 pb-0 px-4 lg:px-8 transition-colors duration-300">
            <div className="max-w-4xl mx-auto bg-white dark:bg-earth-800 rounded-3xl p-8 lg:p-12 shadow-xl border border-earth-100 dark:border-earth-700 mb-12">
                <h1 className="text-4xl font-bold text-earth-900 dark:text-earth-50 mb-8">Terms of Service</h1>
                
                <section className="space-y-6 text-earth-700 dark:text-earth-200 leading-relaxed">
                    <p>
                        Last updated: May 21, 2026
                    </p>

                    <h2 className="text-2xl font-bold text-earth-800 dark:text-earth-100 mt-8">1. Acceptable Use</h2>
                    <p>
                        By accessing this website, you agree to use it only for lawful purposes and in a way that does not infringe the rights of, restrict or inhibit anyone else's use and enjoyment of the website.
                    </p>

                    <h2 className="text-2xl font-bold text-earth-800 dark:text-earth-100 mt-8">2. Intellectual Property & Image Licensing</h2>
                    <div className="bg-earth-50 dark:bg-earth-900/50 p-6 rounded-2xl border-l-4 border-earth-500 italic">
                        <p className="font-semibold mb-2 text-earth-900 dark:text-earth-50 underline">Important Notice for Wallpapers Section:</p>
                        <p>
                            All images provided in the "Wallpapers" section are the exclusive property of the author. They are provided solely for personal, non-commercial use as device backgrounds (wallpapers).
                        </p>
                        <p className="mt-4">
                            <strong>Strictly Prohibited:</strong> You may not re-upload, redistribute, modify, sell, or use these images for any commercial purpose or on other websites/platforms without explicit written permission from the author. All rights are reserved.
                        </p>
                    </div>

                    <h2 className="text-2xl font-bold text-earth-800 dark:text-earth-100 mt-8">3. Disclaimer</h2>
                    <p>
                        The materials on this website are provided on an 'as is' basis. We make no warranties, expressed or implied, and hereby disclaim and negate all other warranties including, without limitation, implied warranties or conditions of merchantability, fitness for a particular purpose, or non-infringement of intellectual property or other violation of rights.
                    </p>

                    <h2 className="text-2xl font-bold text-earth-800 dark:text-earth-100 mt-8">4. Limitations</h2>
                    <p>
                        In no event shall the author be liable for any damages (including, without limitation, damages for loss of data or profit, or due to business interruption) arising out of the use or inability to use the materials on this website.
                    </p>

                    <h2 className="text-2xl font-bold text-earth-800 dark:text-earth-100 mt-8">5. Governing Law</h2>
                    <p>
                        Any claim relating to this website shall be governed by the laws of our jurisdiction without regard to its conflict of law provisions.
                    </p>
                </section>
            </div>
            <Footer />
        </main>
    );
};

export default Terms;
